import { render } from "./Navbar.vue?vue&type=template&id=7bf11e5c&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=7bf11e5c&scoped=true&lang=css"

import exportComponent from "D:\\Mindscan\\online-quiz-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf11e5c"]])

export default __exports__